export default {
    contentDialog: {
        maxWidth: 500,
    },
};
